export default "__VITE_ASSET__5838f0b9__"